import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConnectError, createClient } from '@connectrpc/connect';
import { AuthService } from 'proto/gen/ts/shirt/v1/auth_pb';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';
import { useAuthStore } from '../store/authStore';
import { TEST_IDS } from '../utils/testIds';
import { transport } from '../utils/transport';
const authClient = createClient(AuthService, transport);
export default function Login() {
    const [mode, setMode] = useState('login');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const login = useAuthStore((state)=>state.login);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = mode === 'login' ? await authClient.login({
                username,
                password
            }) : await authClient.register({
                username,
                password,
                email: ''
            });
            login(response.token, response.userId, response.username, response.role, response.email);
            navigate(ROUTES.home);
        } catch (err) {
            if (err instanceof ConnectError) {
                setError(err.message);
            } else {
                setError(mode === 'login' ? 'Login failed' : 'Registration failed');
            }
        } finally{
            setLoading(false);
        }
    };
    const switchMode = ()=>{
        setMode(mode === 'login' ? 'register' : 'login');
        setError('');
        setUsername('');
        setPassword('');
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-screen bg-washi-100 flex items-center justify-center px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-md w-full",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jp-card p-8",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center mb-8",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "text-2xl font-heading font-bold text-sumi-900",
                                children: "Elevated"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-2 text-sm text-sumi-600",
                                children: mode === 'login' ? 'Sign in to your account' : 'Create a free account'
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex rounded-md border border-sumi-200 mb-6 overflow-hidden",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>mode !== 'login' && switchMode(),
                                className: `flex-1 py-2 text-sm font-medium transition-colors duration-150 ${mode === 'login' ? 'bg-indigo-jp-800 text-white' : 'text-sumi-600 hover:bg-sumi-50'}`,
                                children: "Sign In"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>mode !== 'register' && switchMode(),
                                className: `flex-1 py-2 text-sm font-medium transition-colors duration-150 ${mode === 'register' ? 'bg-indigo-jp-800 text-white' : 'text-sumi-600 hover:bg-sumi-50'}`,
                                children: "Register"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        onSubmit: handleSubmit,
                        className: "space-y-6",
                        children: [
                            error && /*#__PURE__*/ _jsx("div", {
                                "data-testid": TEST_IDS.loginErrorMessage,
                                className: "bg-shu-50 border border-shu-200 text-shu-700 px-4 py-3 rounded-md text-sm",
                                children: error
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "username",
                                        className: "jp-label",
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        id: "username",
                                        "data-testid": TEST_IDS.loginUsernameInput,
                                        type: "text",
                                        value: username,
                                        onChange: (e)=>setUsername(e.target.value),
                                        className: "jp-input",
                                        placeholder: "Enter your username",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "password",
                                        className: "jp-label",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        id: "password",
                                        "data-testid": TEST_IDS.loginPasswordInput,
                                        type: "password",
                                        value: password,
                                        onChange: (e)=>setPassword(e.target.value),
                                        className: "jp-input",
                                        placeholder: mode === 'register' ? 'At least 6 characters' : 'Enter your password',
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "submit",
                                "data-testid": TEST_IDS.loginSubmitButton,
                                disabled: loading,
                                className: "jp-btn-primary w-full",
                                children: loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : 'Create Account'
                            })
                        ]
                    })
                ]
            })
        })
    });
}
